import axios from 'axios';

export const uploadFile = ({
  data,
  config = {},
}: {
  data: any;
  config?: import('axios').AxiosRequestConfig;
}) =>
  axios.post('/api/v1/upload', data, {
    ...config,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const uploadCourseFile = (
  { data, config }: { data: any; config: import('axios').AxiosRequestConfig },
  requestParams: any,
) =>
  axios.post(`/api/v1/upload/course/${requestParams.courseId}`, data, {
    ...config,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const uploadLessonFile = (
  { data, config }: { data: any; config: import('axios').AxiosRequestConfig },
  requestParams: { lessonId: string },
) =>
  axios.post(`/api/v1/upload/lesson/${requestParams.lessonId}`, data, {
    ...config,
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const removeFile = (data: any) =>
  axios.post('/api/v1/upload/remove', data);

export const copyFile = (data: any) => axios.post('/api/v1/upload/copy', data);
